import DiaryEntryCalendar from "../DiaryEntry/CalendarView/DiaryEntryCalendar";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Grid, styled, Typography } from "@mui/material";

const StyledAccordion = styled(Accordion)({
  width: "100%",
  maxHeight: 'calc(100vh - 145px)',
  display: 'flex',
  flexDirection: 'column',
  '& .MuiCollapse-root': {
    flexGrow: 1,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  '& .MuiCollapse-wrapper': {
    width: '100%',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  '&.Mui-expanded': {
    margin: 0,
  },
});

const StyledAccordionDetails = styled(AccordionDetails)({
  flexGrow: 1,
  overflowY: 'auto',
  padding: '8px',
});

const StyledAccordionSummary = styled(AccordionSummary)({
  backgroundColor: '#E3F1FF',
  height: 48,
  '&.Mui-expanded': {
    minHeight: 48,
  },
});


const DiaryEntryView: React.FC = () => {
  return (
    <Grid container height="48px" zIndex={100} px={2} mb={2} mt={1} width="100vw" data-testid="diary-entry-view">
      <StyledAccordion defaultExpanded={true}>
        <StyledAccordionSummary expandIcon={<ExpandMoreIcon />} >
          <Typography variant='caption' fontWeight={700}> Report Diary Entries</Typography>
        </StyledAccordionSummary>
        <StyledAccordionDetails>
          <DiaryEntryCalendar />
        </StyledAccordionDetails>
      </StyledAccordion>
    </Grid>
  )
}

export default DiaryEntryView
